import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <>
      <Helmet><title>404 — e-mina.eu</title></Helmet>
      <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="not-found-page">
        <p className="text-7xl font-black text-gray-200 mb-4">404</p>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-3">{t('notfound.title')}</h1>
        <p className="text-gray-500 mb-8">{t('notfound.message')}</p>
        <Link to="/" className="inline-flex px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors font-medium text-sm" data-testid="go-home-btn">
          {t('notfound.home')}
        </Link>
      </div>
    </>
  );
}
